import { initializeOProduct } from './product.const';

type withEventMergeId<T> = T & {
    eventMergeId?: string;
};

export function getGlobalEventMergeId(): string | undefined {
    initializeOProduct();
    return o_product.tracking.eventMergeId;
}

export function setGlobalEventMergeId(eventMergeId?: string): void {
    initializeOProduct();
    o_product.tracking.eventMergeId = eventMergeId;
}

export function generateEventMergeId(): string {
    /*              */
    const chars = [
        '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
        'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm',
        'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
        'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
        'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
    ];
    let id = '';
    for (let i = 0; i < 10; i++) {
        const randomIndex = Math.floor(Math.random() * chars.length);
        id += chars[randomIndex];
    }
    return id;
}

export function getGlobalEventMergeIdIfVariationChanged(): string | undefined {
    return o_product.state.isVariationChanged ? getGlobalEventMergeId() : undefined;
}

/**
 *
 */
export function addEventMergeIdIfVariationChangedAndExists<T>(payload: T): withEventMergeId<T> | T {
    const eventMergeId = getGlobalEventMergeIdIfVariationChanged();
    if (eventMergeId !== undefined) {
        return {
            ...payload,
            eventMergeId,
        };
    }

    return payload;
}
